export enum MatchStatisticStatus {
  OK = 1,
  POSTING = 2,
  PATCHING = 4,
}
